import { RequestType } from 'nanium/objects';
import { ServiceRequestBase } from '../serviceRequestBase';

export interface BroadcastMessageRequest {
  message: {
    title: string;
    body: string;
    data?: { [key: string]: string };
    imageUrl?: string;
  };
  topic?: string; // If provided, sends to topic instead of all users
}

export interface BroadcastMessageResponse {
  success: boolean;
  totalUsers?: number;
  messagesAttempted?: number;
  messagesSucceeded?: number;
  messagesFailed?: number;
  messageId?: string; // For topic messages
  errors?: string[];
}

@RequestType({
  responseType: Object,
  genericTypes: { TRequestBody: Object },
  scope: 'public'
})
export class BroadcastMessageServiceRequest extends ServiceRequestBase<BroadcastMessageRequest, BroadcastMessageResponse> {
  static serviceName: string = 'NaniumDemo:firebase/broadcastMessage';
}
